import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

export const api = createApi({
    baseQuery: fetchBaseQuery({baseUrl:process.env.REACT_APP_BASE_URL}),
    reducerPath: "api",
    tagTypes:["User", "Products","Customers","Transactions"],
    endpoints: (build) => ({
        registerUser: build.mutation({
            query: (body) => ({
              url: 'auth/register',
              method: 'POST',
              body,
            }),
          }),
          loginUser: build.mutation({
            query: (body) => ({
              url: 'auth/login',
              method: 'POST',
              body,
            }),
          }),
        getUser:build.query({
            query:(id) => `general/user/${id}`,
            providesTags:["User"]
        }),
        getProducts:build.query({
            query: () => "clients/products",
            providesTags: ["Products"],
        }),
        getCustomers: build.query({
            query: () => "clients/customers/",
            providesTags: ["Customers"]
        }),
        getTransactions: build.query({
            query: ( {page, pageSize, sort, search}) => ({
                url: "clients/transactions",
                method: "GET",
                params: {page, pageSize, sort, search},
            }),
            providesTags: ["Transactions"],
        })
    }),
});



export const {
    useRegisterUserMutation,
    useLoginUserMutation,
    useGetUserQuery,
    useGetProductsQuery,
    useGetCustomersQuery,
    useGetTransactionsQuery,
} = api;
